import{jsxs as e,Fragment as t,jsx as n}from"react/jsx-runtime";import{forwardRef as a,useState as r,useEffect as o}from"react";import{ArrowRight as i,Calendar as l,X as s}from"lucide-react";import d from"clsx";import m from"tailwind-styled-components";import c from"../input/input.js";const h=m.div`
  range-input-container
  bg-white
  border-t
  border-t-transparent
  inline-flex
  items-center
  outline-none
  relative
  rounded
  shadow
  transition-all
  w-full

  md:w-auto

  hover:border-t-gray-50
  hover:-translate-y-px
  hover:shadow-brand-primary/20
  hover:shadow-lg
`,p=m.input`
  absolute
  opacity-0
  w-0
  h-0
  invisible
`,u=m(c)`
  shadow-none
  border-none
  flex-1
  rounded-l
  !translate-y-0
  hover:shadow-none
  hover:translate-y-0
`,f=m(c)`
  shadow-none
  border-none
  flex-grow
  rounded-r
  flex-1
  !translate-y-0
  hover:shadow-none
  hover:translate-y-0
`,v=m(i)`
  -translate-x-1/2
`,x=m.button`
  [font-size:.5em]
  !absolute
  bg-gray-400
  flex-shrink-0
  h-4
  inline-flex
  items-center
  justify-center
  leading-none
  p-[2px]
  right-3
  rounded-full
  text-white
  transition-opacity
  w-4
`,g=a((({$isFocused:a,size:i="normal",onClear:m,onClick:c,...g},w)=>{const[y,b]=r(""),[C,z]=r(""),N=d(g.className,{"range-input-container--focused":a,"range-input-container--has-end":C.trim().length>0,"range-input-container--has-start":y.trim().length>0,"text-sm pr-6 md:max-w-[18rem]":"small"===i,"text-base md:max-w-sm":"normal"===i}),k=d({"text-sm md:text-sm":"small"===i}),I=d({"text-sm md:text-sm":"small"===i}),j=d({"opacity-0 pointer-events-none":!(y.trim().length>0||C.trim().length>0)});return o((()=>{if("string"==typeof g.value){const[e="",t=""]=g.value.split(" - ");b(e),z(t)}}),[g.value]),e(t,{children:[n(p,{...g,ref:w}),e(h,{onClick:c,className:N,size:i,children:[n(u,{autoComplete:"off",className:k,name:"start-date",onInvalid:g.onInvalid,placeholder:"Start date",prefix:n(l,{}),readOnly:!0,size:i,variant:"ghost",value:y}),n(f,{autoComplete:"off",className:I,name:"end-date",onInvalid:g.onInvalid,placeholder:"End date",prefix:n(v,{}),readOnly:!0,size:i,variant:"ghost",value:C}),n(x,{className:j,onClick:()=>{b(""),z(""),"function"==typeof m&&m()},role:"button",children:n(s,{})})]})]})}));export{g as default};
